import { Button, DialogBox } from "@/_component/Common";
import { copyToClipboard, timeout } from "@/utility";
import { useState } from "react";

export default function SharePopup({ title = "Share with Others", subject, content, onClose }) {
    const [copy, setCopy] = useState(false);

    const handleCopyText = () => {
        copyToClipboard(content)
            .then(_ => {
                setCopy(true);
                timeout(_ => setCopy(false), 5000);
            });
    }

    const handleWhatsAppShare = () => {
        if (!content.trim()) {
            return;
        }
        const encodedText = encodeURIComponent(content.trim());
        const whatsappUrl = `https://wa.me/?text=${encodedText}`;
        window.open(whatsappUrl, "_blank");
    };

    const handleEmailShare = () => {
        if (!content.trim()) {
            return;
        }
        const encodedSubject = encodeURIComponent(subject || "Check out this details");
        const body = encodeURIComponent(content.trim());
        const emailUrl = `mailto:?subject=${encodedSubject}&body=${body}`;
        window.location.href = emailUrl;
    };

    return (
        <DialogBox title={title} onClose={onClose}>
            <div>
                <div className="d-flex align-items-center gap-2">
                    <Button noSpacing onClick={handleEmailShare}><i className="py-1 px-2 text-primary bi bi-envelope fs-2"></i></Button>
                    <Button noSpacing onClick={handleWhatsAppShare}><i className="py-1 px-2 text-success bi bi-whatsapp fs-3"></i></Button>
                </div>
                <div className="d-flex gap-2 align-items-center mt-2">
                    <input type="text" className="form-control form-control-sm" defaultValue={content} />
                    <Button primary solid small onClick={handleCopyText} disabled={copy}>{copy ? "Copied" : "Copy"}</Button>
                </div>
            </div>
        </DialogBox>
    )
}